<template>
  <div class="thumb" v-cloak :class="{'thumb--active': isActive}" @mouseleave="close">
    <a class="thumb__img" @click="go" :href="link" :id="id" :data-position="position" :target="target" :data-link="link" v-lazy="image"></a>
    <div class="thumb__duration">{{durationFix}}</div>
    <div class="thumb__header">
      <a :href="link" :target="target" @click="go" class="thumb__title">{{title}}</a>
      <div class="thumb__tags">
        <span v-html="sponsor"></span>
        <slot></slot>
      </div>
      <i class="i i-arrow i-4"  :class="{'i-rotate': isActive}" @click="toggle"></i>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
export default {
  props: {
    title: String,
    id: String,
    href: String,
    image: String,
    duration: String,
    ext: String,
    lazy: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    position: window.position++,
    isBig: false,
    isActive: false,
    site: ''
  }),
  computed: {
    target: function() {
      return '_blank';

      if(this.$cjer.getCookie(this.site)) {
        return '_blank';
      }
      return '_self';
    },
    link: function() {
      if( this.ext.indexOf('?') > -1) {
        return `${this.ext}&${this.$root.$cjer.utmString()}`;
      } else {
        return `${this.ext}?${this.$root.$cjer.utmString()}`;
      }
      

      if(this.$cjer.getCookie(this.site)) {
        return `${this.ext}?${this.$root.$cjer.utmString()}`;
      }
      return this.href;
    },
    background: function() {
      if(this.lazy == false ) {
        return `background-image:url(${this.image});`;
      }
    },
    durationFix() {
      return this.duration.length<3 ? '00:'+this.duration : this.duration;
    },
    sponsor() {
      let text = this.$slots.sponsor[0].children[0].text;
      this.site = text;
      return `<a class="thumb__sponsor" href="${this.$slots.sponsor[0].data.attrs.href}">${text.replace('videotxxx', 'txxx')}</a>`
    }

  },
  mounted () {
    
    //this.isBig = this.$refs.tags.clientHeight > 18 ? true : false;
  },
  methods: {
    go(e) {
      axios.get(this.href).then(res=>{
        console.log(res)
      })
      if(this.$cjer.getCookie(this.site)) {
        // let url = `${this.ext}?${this.$root.$cjer.utmString()}`
        // window.open(url)
        return;
      }

      this.$cjer.setCookie(this.site, 1, 60);
      //window.location = this.href;
    },
    toggle() {
      this.isActive = !this.isActive;
    },
    open() {
      this.isActive = true;
    },
    close() {
      this.isActive = false;
    }
  },
  created() {
    
  }
}
</script>
